let apiVersion = "v1";

// Update User
export const createUser = `user/${apiVersion}/create`;

export const findUser = (name) => `users/${apiVersion}/findUser/${name}`;
export const mentionUser = `users/${apiVersion}/mention-user`;
export const downloadAllUsers = `/public/${apiVersion}/download-all-users`;
export const getDownloadLink = `users/${apiVersion}/download-link`;
export const loginUser = `auth/${apiVersion}/login`;

export const resendOTP=`auth/${apiVersion}/resend-otp`
// export const logoutUser = `auth/${apiVersion}/logout`
export const logoutUser = `auth/${apiVersion}/logout`;
export const verifyOTP=`auth/${apiVersion}/verify-otp`
export const sentOtpForPhone=`/auth/${apiVersion}/verify-phone`
export const qrCodePhoneSignup = `users/${apiVersion}/qr-code-phone-signup`;

export const removeIntro = `/users/${apiVersion}/remove-intro`;
// export const updateUser = `users/${apiVersion}/user`;
export const updateUser = `users/${apiVersion}/update-user`;

export const addMembers = `users/${apiVersion}/add-members`;
export const addMembersViaCsv = `users/${apiVersion}/add-members-via-csv`;
export const addMemberInOffice = `users/${apiVersion}/office/add-member`;

export const getRecentUsers = `/users/${apiVersion}/getRecentUsers`;

// activityBarUserMetrics
export const activityBarUserMetrics = `/users/${apiVersion}/activityBarUserMetrics`;

export const requestPasswordLink = `auth/${apiVersion}/reset-link-request`;
export const setPassword = `auth/${apiVersion}/reset-password?token=`;
export const changePassword = `users/${apiVersion}/change-password`;
export const editLoginInfo = `users/${apiVersion}/change-password-with-confirm-pass`;
// export const editProfileInfo = `users/${apiVersion}/user`;
export const editProfileInfo = `users/${apiVersion}/update-user`;

export const getUserProfile = (id, org) =>
  `users/${apiVersion}/${org}/profile/${id}`;

// export const logout = `auth/${apiVersion}/logout`;
export const fetchOfficeDetails = (officeId) =>
  `office/${apiVersion}/office/${officeId}`;

export const removeFromFavorites = `/toolkit/${apiVersion}/tools/remove-favorite`;

export const addToFavorites = `/toolkit/${apiVersion}/tools/add-favorite`;

export const fetchToolkitsByCategory = (category, option) =>
  category === "Favorites"
    ? `/toolkit/${apiVersion}/favorites`
    : category === "Archive"
    ? `/toolkit/v1/tools/archive-list`
    : `toolkit/${apiVersion}/tools/${category}/${option}`;
export const fetchToolkitsByCategoryFilter = (category, option) =>
  category === "Favorites"
    ? `/toolkit/${apiVersion}/filter/favorites`
    : category === "Archive"
    ? `/toolkit/v1/tools/filter/archive-list`
    : `toolkit/${apiVersion}/tools/filter/${category}/${option}`;

export const updateOffice = (officeId) =>
  `office/${apiVersion}/office/${officeId}`;

export const sendUserInvites = `toolkit/${apiVersion}/send-user-event-invites`;
export const sendEventReminds = `toolkit/${apiVersion}/send-event-reminds`;

export const removeRsvp = `toolkit/${apiVersion}/removeRsvp`;

export const findEventGuests = `toolkit/${apiVersion}/findEventGuests`;
export const getUserEvents = `toolkit/${apiVersion}/getUserEvents`;
export const getSingleUserEvent = `toolkit/${apiVersion}/getSingleUserEvent`;
export const changeEventStatus = `toolkit/${apiVersion}/changeEventStatus`;

export const fetchTools = `toolkit/${apiVersion}/getTools`;
export const fetchAttachedTools = `toolkit/${apiVersion}/linked-tools`;

// Group APIs
export const createGroup = "/groups/v1/create-group";
export const updateGroup = "/groups/v1/update-group";
export const showGroup = "/groups/v1/get-single-group";
export const getGroups = "/groups/v1/get-groups";
export const getItemsGroup = "/groups/v1/get-items-groups";
export const attachItemGroup = "/groups/v1/attach-item-group";
export const removeGrpItem = "/groups/v1/remove-linked-item";
export const getSingleGroupItems = "/groups/v1/get-group-items";
export const addGroupMembers = "/groups/v1/add-group-members";
export const joinGroup = "/groups/v1/join-group";
export const archiveSingleGroup = "/groups/v1/archive-single-group";
export const removeGroupMembers = "/groups/v1/remove-group-members";
export const changeGroupRole = "/groups/v1/change-group-role";
export const groupUserRole = "/groups/v1/group-user-role";

// export const getGroupMetrics = (orgId) => `/groups/v1/group-metrics/${orgId}`;

export const getGroupMetrics = `/groups/v1/group-metrics`;

// Search APIs
export const searchImages = "/search/v1/suggest-images";
export const searchVideos = "/search/v1/suggest-videos";
export const searchGiphy = "/search/v1/suggest-giphy";
export const geolocate = "/search/v1/geolocate";

// export const
export const getAllFoucsList = `toolkit/${apiVersion}/filters`;
export const addTool = `toolkit/${apiVersion}/tool`;
export const getTool = (id) => `toolkit/${apiVersion}/tool/${id}`;
export const editTool = (toolId) =>
  `toolkit/${apiVersion}/update-tool/${toolId}`;
export const getRecentEvent = `toolkit/${apiVersion}/recent-event`;
export const archiveTools = `toolkit/${apiVersion}/tools/archive`;
export const restoreTool = `toolkit/${apiVersion}/tools/restore`;
export const rateTool = (toolId) =>
  `toolkit/${apiVersion}/tools/rate/${toolId}`;
export const getToolkitComments = (id) =>
  `toolkit/${apiVersion}/tools/comment/${id}`;
export const addToolkitComment = `toolkit/${apiVersion}/tools/comment`;
// export const addToolkitComment = id => `toolkit/${apiVersion}/tools/comment/${id}`;
export const deleteToolkitComment = (tid, cid) =>
  `/toolkit/v1/tools/comment/${tid}/${cid}`;

export const removeFromFavoritesChart = (chartId) =>
  `/charts/${apiVersion}/chart/favorite/${chartId}`;
export const addToFavoritesChart = (chartId) =>
  `/charts/${apiVersion}/chart/favorite/${chartId}`;
// favorites hits endpoint chart-fav-list
export const fetchAnalyticsByCategory = (
  category,
  pageNumber,
  count,
  chartId
) =>
  category === "Favorites"
    ? `charts/${apiVersion}/chart-fav-list`
    : category === "Archive"
    ? `charts/${apiVersion}/chart-archive-list`
    : chartId
    ? `charts/${apiVersion}/chart-list/${category}`
    : `charts/${apiVersion}/chart-list/${category}`;

// export const fetchCharts = (category, pageNumber, count) =>  `charts/${apiVersion}/getCharts/${category}?pageNumber=${pageNumber}&&display=${count && count!=null?count:5}`

export const fetchCharts = `charts/${apiVersion}/getCharts`;
export const fetchAttachedCharts = `charts/${apiVersion}/linked-charts`;

export const searchAnalyticsByCategory = (category, chartName) =>
  `charts/${apiVersion}/search-charts/${category}?chartName=${chartName}`;

// Analytics
export const getToolkitCategoryFocus = `/category/${apiVersion}/getToolkitCategoryFocus`;

export const getCategoryKpiData = `/category/${apiVersion}/kpi-list-with-aggregate/`;
export const getCategoryKpiList = `/category/${apiVersion}/kpi-list/`;
export const getAllBenchmarkList = `/category/${apiVersion}/occupation-and-industry-list`;
export const archiveChart = (chartId) =>
  `/charts/${apiVersion}/chart/archive/${chartId}`;

export const addComment = (chartId) =>
  `/charts/${apiVersion}/chart/comment/${chartId}`;
export const getComments = (chartId) =>
  `/charts/${apiVersion}/chart/comment/${chartId}`;
export const deleteComment = (chartId, commentId) =>
  `/charts/${apiVersion}/chart/comment/${chartId}/${commentId}`;
export const getBenchmarkScore = `/benchmarks/${apiVersion}/benchmark/`;
export const createChart = `/charts/${apiVersion}/chart`;
// export const editChart = `/charts/${apiVersion}/chart`;
export const editChart = (chartId) => `/charts/${apiVersion}/chart/${chartId}`;

export const setGoal = (chartId) =>
  `/charts/${apiVersion}/chart/goal/${chartId}`;
export const getHierarchyData = `/kpiAggregates/v2/kpiAggregate-with-hierarchy`;
export const getBenchmarkHierarchy = `/benchmarks/${apiVersion}/benchmark-with-hierarchy`;
export const updateGoal = (chartId, goalId) =>
  `/charts/${apiVersion}/chart/goal/${chartId}/${goalId}`;
export const deleteGoal = (chartId, goalId) =>
  `/charts/${apiVersion}/chart/goal/${chartId}/${goalId}`;
export const restoreChart = (chartId) =>
  `/charts/${apiVersion}/chart/restore/${chartId}`;
export const getkpiAggregate = `/kpiAggregates/v2/kpiAggregate`;
export const refreshChart = (chartId) =>
  `/charts/${apiVersion}/chart/refresh/${chartId}`;

// Office
export const getOfficeMates = `/office/${apiVersion}/office/office-mates/`;
// export const addMemberInOffice = `/office/${apiVersion}/office/add-member`;

export const getDiversityTypes = `/users/${apiVersion}/getDiversityTypes`;

export const changeTableLayout = `/users/${apiVersion}/modify-table-layout`;

export const changeRole = (userId) =>
  `/users/${apiVersion}/change-role/${userId}`;

export const changeMobileNumber = (userId) =>
  `/users/${apiVersion}/change-mobile-number/${userId}`;
export const changeEmailId = (userId) =>
  `/users/${apiVersion}/change-email-id/${userId}`;
// Add endpoint for changing user names
export const changeUserNames = (userId) =>
  `/users/${apiVersion}/change-user-names/${userId}`;
export const changeUserOffice = `/users/${apiVersion}/changeUserOffice`;
export const updateNotificationPrefs = `/users/${apiVersion}/update-notification-prefs`;

export const removeOfficeMate = `/users/${apiVersion}/delete/`;
export const getOccupationCustomerProductList = `category/${apiVersion}/occupation-customer-product-list`;
export const getIndustryList = `category/${apiVersion}/industry-list`;

// Dani
export const getSearchResults = `/dani/v1/dani/search`;
// Notificatios
// export const getNotifications = `/notifications/${apiVersion}/notifications?resultsPerPage=10&pageNumber=&mobile=`;
export const getNotifications = `/notifications/${apiVersion}/notifications/`;

export const getEngagementMetrics = `/notifications/${apiVersion}/engagementMetrics`;

export const markNotificationAsRead = `/notifications/${apiVersion}/notification/read/`;
export const markAllNotificationsAsRead = `/notifications/${apiVersion}/notifications/mark-all-read`;
export const getNotificationDetails = (id) =>
  `/notifications/${apiVersion}/notification/${id}`;

//Todos
export const addTodo = `/tasks/${apiVersion}/task`;
export const editTodo = `/tasks/${apiVersion}/task/update-task`;
export const getTodos = (taskType, actionId) =>
  `/tasks/${apiVersion}/task-list?taskType=${taskType}${
    actionId ? `&actionId=${actionId}` : ""
  }`;
export const attachItemsTodo = `/tasks/${apiVersion}/task/attach-items`;
// removeItemsTodo
export const removeItemsTodo = `/tasks/${apiVersion}/task/remove-items`;

//Stories
export const getStories = `/stories/v1/stories-list`;
export const getSpotlight = `/stories/v1/spotlight`;
export const getStoriesbyfilter = `/stories/v1/stories-list-by-filter`;

// export const getStories = (organizationId, value) => `/stories/v1/stories-list/${organizationId}/${value}`;
// export const getStories = (orgId, value) => `/stories/v1/stories-list/${orgId}/${value}`;

export const getTrending = (orgId, value) =>
  `/stories/v1/trending/${orgId}/${value}`;
export const getSingleStory = (value) => `/stories/v1/story/${value}`;

export const createStory = `/stories/v1/stories`;
// export const createStory = `/stories/v1/stories`;
export const editStory = (storyId) =>
  `/stories/v1/stories/editStory/${storyId}`;

// export const createStoryResponse= (storyId) => `/stories/v1/stories/comment/${storyId}`;

export const createStoryResponse = `/stories/v1/stories/comment`;

export const addReaction = (storyId) =>
  `/stories/v1/stories/reaction/${storyId}`;
export const userReactions = (storyId) =>
  `/stories/v1/stories/userReactions/${storyId}`;

export const getOpenGraphData = `/stories/v1/stories/getOpenGraphData`;

export const getStoryComments = (itemdId) =>
  `/stories/v1/stories/replies/${itemdId}`;
// export const createStoryResponse = (storyId) => `/tasks/v1/stories/${storyId}`;
export const archiveStory = (storyId) =>
  `/stories/v1/stories/archiveStory/${storyId}`;
export const deArchiveStory = (storyId) =>
  `/stories/v1/stories/deArchive/${storyId}`;
export const removeStoryFeeds = (storyId) =>
  `/stories/v1/stories/removeStory/${storyId}`;
export const deleteReaction = (storyId, userId) =>
  `/stories/v1/stories/deleteReaction/${storyId}/${userId}`;
// export const getSentiment = `/stories/v1/stories/sentiment`;

export const flagContent = (storyId) => `/stories/v1/flagContent/${storyId}`;
export const showFlaggedContent = `/stories/v1/show-flagged-content`;
// `/stories/v1/spotlight`;
// export const getSentiment = (text) => `users/${apiVersion}/findUser/${name}`;
export const getSentiment = `/stories/v1/stories/sentiment`;

// export const getTodos = (taskType) = `/tasks/${apiVersion}/task-list?taskType=`;
export const markComplete = (id) =>
  `/tasks/${apiVersion}/task/mark-completed/${id}`;
export const markIncomplete = (id) =>
  `/tasks/${apiVersion}/task/mark-incomplete/${id}`;

export const deleteTodo = (id) => `/tasks/${apiVersion}/archiveTask/${id}`;
export const undeleteTodo = (id) => `/tasks/${apiVersion}/unarchiveTask/${id}`;

export const getSingleTask = `/tasks/v1/getSingleTask`;

export const getActionsPieChart = `/tasks/v1/getActionsPieChart`;
export const getAvgTaskCompletion = `/tasks/v1/getAvgTaskCompletion`;
export const latestObjectiveActivity = `/tasks/v1/latestObjectiveActivity`;
export const getTotalActionCount = `/tasks/v1/getTotalActionCount`;
export const getUniqueActionOwners = `/tasks/v1/getUniqueActionOwners`;
export const getUniqueActionActivity = `/tasks/v1/getUniqueActionActivity`;
//Master Category List
export const getMasterListByCategory = (category) =>
  `/category/${apiVersion}/category/${category}`;

export const categoriesList = `/category/${apiVersion}/getDiversityTypes`;

export const getTopics = (organizationId) =>
  `/category/v1/get-topics/${organizationId}`;

//Organisation Setup

export const getSignedUrl = `/organization/${apiVersion}/getSignedUrl`;

export const skippedAnalytic = `/organization/${apiVersion}/skip-setup`;

export const storeStartPage = `/organization/${apiVersion}/store-start-page`;

// org chart hierarchies
export const saveOrgChart = `/orgchart/${apiVersion}/save`;
export const getOrgCharts = (pageNumber) =>
  `/orgchart/${apiVersion}/versions?pageNumber=${pageNumber}`;

export const saveHierarchyMapping = `/hierarchyMapping/${apiVersion}/hierarchyMapping`;
export const saveMapping = `/mappings/${apiVersion}/mapping`;
export const skipMapping = `/mappings/${apiVersion}/skipMapping`;

export const getExistingMappings = (orgId) =>
  `/mappings/${apiVersion}/mapping/${orgId}`;

export const inviteAdminsForOffices = `/users/${apiVersion}/invite-office-admins-all-offices`;

export const assignSelfOffice = `/users/${apiVersion}/self-invite-to-office-admin`;
export const skipStepFor = (type) => `/users/${apiVersion}/skip-setup/${type}`;

export const hierarchyNameChange = `/hierarchyMapping/${apiVersion}/hierarchyNameChange`;

// Announcements

export const currentAnnouncement = `/announcements/v1/current`;
export const addAnnouncement = `/announcements/v1/addAnnouncement`;
export const archiveAnnouncement = "/announcements/v1/archiveAnnouncement";
export const editAnnouncement = `/announcements/v1/editAnnouncement`;
export const addAnnouncementReaction = `/announcements/v1/addReaction`;
export const removeAnnouncementReaction = `/announcements/v1/removeReaction`;
export const userAnnouncementReactions = (id) =>
  `/announcements/v1/getReactions/${id}`;

//Get all Kpis
export const getKpiMaster = `/category/${apiVersion}/kpi-list`;

//Manual entry
export const saveSurvey = `/surveys/${apiVersion}/survey`;
// export const getExistingSurvey = (payload) => `/surveys/${apiVersion}/survey-latest/${payload}`;
export const getExistingSurvey = `/surveys/${apiVersion}/survey-latest/`;

//Employee data upload
export const saveEmployeeData = `/employees/${apiVersion}/employees`;

// Applicant data upload
export const saveApplicantData = `/applicants/${apiVersion}/applicants`;

//get existing offices with invited admins
export const getCurrentOffices = (id) =>
  `/office/${apiVersion}/office/office-list-with-admins/${id}`;

//update organization
export const updateIndustryForOrganization = `/organization/${apiVersion}/org/update-industry`;
export const updateNameForOrganization = `/organization/${apiVersion}/org/update-name`;
export const getOrgUserList = `/users/${apiVersion}/org-users-list`;
export const fetchUsers = "/users/v1/fetchUsers";
export const searchUsersForListing = "/users/v1/searchUsersForListing";
export const searchUsers = "/users/v1/searchUsers";
// userListArray
export const userListArray = "/users/v1/userListArray";
export const userListArrayForTrivvyShare = `/users/v1/userListArrayForTrivvyShare`;

export const shareToolWithOther = (toolId) =>
  `/toolkit/${apiVersion}/tools/public-share/${toolId}`;
export const getPublicTool = (toolId) => `/public/tool/${toolId}`;
export const removeOfficeAdmins = `/users/v1/remove-office-admins`;

export const checkOrgEmail = `/organization/${apiVersion}/findOrganization`;

export const changeOfficeNames = `/organization/${apiVersion}/changeOfficeNames`;

export const findOrgById = (orgId) =>
  `/organization/${apiVersion}/org/${orgId}`;
export const findOrgByIdPublic = (orgId) => `/public/${apiVersion}/org/${orgId}`;
export const updateOrgById = (orgId) =>
  `/organization/${apiVersion}/org/${orgId}`;

export const addOrgEmailRule = `/organization/${apiVersion}/addOrgEmail`;
export const addSlackWorkspaceUrl = `/organization/${apiVersion}/addSlackWorkspaceUrl`;
export const addTeamsTenantId = `/organization/${apiVersion}/addTeamsTenantId`;

export const removeSlackWorkspaceUrl = `/organization/${apiVersion}/removeSlackWorkspaceUrl`;
export const removeTeamsTenantId = `/organization/${apiVersion}/removeTeamsTenantId`;

export const saveMailer = `/organization/${apiVersion}/saveMailer`;

export const enableModule = `/organization/${apiVersion}/enableModule`;

export const changeOrgOAuth = `/organization/${apiVersion}/changeOrgOAuth`;

export const restrictModuleSettings = `/organization/${apiVersion}/restrictModuleSettings`;

export const whiteLabel = `/organization/${apiVersion}/whiteLabel`;

export const getMailer = (orgId) =>
  `/organization/${apiVersion}/getMailer/${orgId}`;

export const removeOrgEmailRule = `/organization/${apiVersion}/removeOrgEmailRule`;
export const saveEmployeeNumber = `/organization/${apiVersion}/saveEmployeeNumber`;

// Enterprise Objectives Actions
export const getEnterpriseObjectives = `/tasks/v1/enterpriseObjective-list`;
export const archiveObjective = "/tasks/v1/archiveObjective";

export const unarchiveObjective = "/tasks/v1/unarchiveObjective";

export const addEnterpriseObjective = "/tasks/v1/enterpriseObjective";
export const updateEnterpriseObjective = "/tasks/v1/enterpriseObjective/update";
export const getEnterpriseObjectiveActions =
  "/tasks/v1/enterpriseObjective/linkedActions";
export const unlinkEnterpriseObjectiveAction =
  "/tasks/v1/enterpriseObjective/unlink-action";

export const unlinkSubAction = "/tasks/v1/unlink-subAction";

export const linkEnterpriseObjectiveAction = "tasks/v1/task/link-action";

export const taskUploadFiles = `tasks/v1/task/upload-files`;
export const taskRemoveFiles = `tasks/v1/task/remove-upload-files`;

// Stories

// Dashboard
export const getUserData = `/users/v1/user-metrics/`;
export const getUserAnalytics = (diversity) =>
  `/users/v1/userAnalytics/${diversity}`;
export const getCumulativeAnalytics = (result) =>
  `/users/v1/cumulativeAnalytics/${result}`;
// export const getMailer = (orgId) =>`/organization/${apiVersion}/getMailer/${orgId}`;

// Dashboard APIs
export const createDashboard = "/dashboard/v1/create-dashboard";

// export const changeChartIndex = "/dashboard/v1/change-chart-index";

export const changeChartIndex = "/dashboard/v1/change-chart-order";

export const getDashboard = "/dashboard/v1/get-dashboard";
export const getDashboardList = "/dashboard/v1/dashboard-list";
export const updateDashboard = "/dashboard/v1/update-dashboard";
export const dashboardDateChange = "/dashboard/v1/dashboard-date-change";
export const archiveDashboard = "/dashboard/v1/archive-dashboard";
export const getChartDashboards = "/charts/v1/chart-dashboard-list";
export const insertCharts = "/charts/v1/insert-charts";
export const getDashboardCharts = "/charts/v1/dashboard-charts";
export const lockUnlockChart = "/charts/v1/chart-lock-unlock";

export const dashboardUploadFiles = "/dashboard/v1/upload-files";
export const dashboardRemoveUploads = "/dashboard/v1/remove-uploads";

export const createChartInsight = "/charts/v1/createChartInsight";
export const editChartInsight = "/charts/v1/editChartInsight";
export const removeChartInsight = "/charts/v1/removeChartInsight";

export const previewDashboardChartData = (chartId) =>
  `/charts/v1/dashboard-charts-data-preview/${chartId}`;

export const updateDashboardChartsData = (chartId) =>
  `/charts/v1/dashboard-charts-data/${chartId}`;
export const updateDashboardChart = "/charts/v1/dashboard-charts-update";
export const archiveDashboardChart = "/charts/v1/dashboard-archive-chart";

export const createDashboardNote = "/charts/v1/dashboard-note-created";

export const getImports = "/orgdata/v1/history/";

// export const getToolKitAnalytics = `/toolkit/v1/org-tools/`;
// export const getChartAnalytics = `/charts/v1/org-charts/`;
export const getActionAnalytics = `/tasks/v1/actions/org-actions/`;
export const getStoriesAnalytics = `/tasks/v1/stories/org-stories/`;

export const getToolKitAnalytics = `/toolkit/v1/tool-metrics/`;
export const getChartAnalytics = `/charts/v1/chart-metrics/`;

// user Mentions
export const userMention = `/users/${apiVersion}/userMentions`;

export const chatHelp = `/ai-chat/${apiVersion}/query-response`;

export const handleDatabaseQuestion = `/ai-chat/${apiVersion}/question-to-database`;

export const sendAnswerFeedback = `/dani/${apiVersion}/answer-feedback`;

export const postSocialShare = `/ai-chat/${apiVersion}/dani-social-post`;
export const getSlackChannels = `/ai-chat/${apiVersion}/get-slack-channels`;
export const getTeamsChannels = `/ai-chat/${apiVersion}/get-teams-channels`;
export const shareStoryPost = `/stories/v1/share-story`;
export const changeGroupAnonimity = `/groups/v1/change-group-member-anonimity`;
export const getFlaggedContentHistory = `/stories/v1/stories/getFlaggedContentHistory`;
export const getUserMetricsActionsCount = `/users/v1/get-metrics`;

export const createTrivia = `/trivia/${apiVersion}/create-trivia`;
export const getTriviaList = `/trivia/${apiVersion}/get-trivia`;
export const getTriviaBreakingNewsList = `/news/${apiVersion}/list`;
export const getAllTriviaList = `/trivia/${apiVersion}/get-trivia/list`;
// get-trivia/rewards-list"
export const getDraftsTrivvyList = `/trivia/${apiVersion}/get-trivia/draft-list`;
export const generateReward = `/trivia/${apiVersion}/generate-reward`;
export const getAllRewardsList = `/trivia/${apiVersion}/get-rewards/list`;
export const linkTriviaRewards = `/trivia/${apiVersion}/link-trivia-records`;
export const unlinkTriviaRewards = `/trivia/${apiVersion}/unlink-trivia-records`;
export const getTriviaForEdit = (id, noLoad) =>
  `/trivia/${apiVersion}/get-trivia/${id}/edit?noLoad=${noLoad}`;
export const getTriviaFilteredResults = (id, noLoad) =>
         `/trivia/${apiVersion}/get-trivia/${id}/filtered-results?noLoad=${noLoad}`;
export const getTriviaForEditPublic = (id, noLoad, organizationId) =>
         `public/${apiVersion}/get-trivia/${id}/edit?noLoad=${noLoad}&organizationId=${organizationId}`;
export const getTriviaForQuiz = (id) =>
  `/trivia/${apiVersion}/get-trivia/${id}/quiz`;
export const getTrivvyById = (id) =>
  `/trivia/${apiVersion}/getTrivvyById/${id}`;
export const getTrivvyLinkedRewards = (id) =>
  `/trivia/${apiVersion}/getTrivvyLinkedRewards/${id}`;
export const editTrivia = (id) => `/trivia/${apiVersion}/edit-trivia/${id}`;
export const shareTrivia = (id) => `/trivia/${apiVersion}/share-trivia/${id}`;
export const deleteTrivia = (id) => `/trivia/${apiVersion}/delete-trivia/${id}`;
export const generateTriviaQuestions = `/trivia/${apiVersion}/generate-questions-for-trivia`;
export const removeToolAttachments = `toolkit/${apiVersion}/removeAttachment`;
export const uploadTriviaImages = `/trivia/${apiVersion}/uploadTriviaImages`;
export const addTriviaResponse = `/trivia/${apiVersion}/add-trivia-responses`;
export const submitTriviaResponse = (id) =>
  `/trivia/${apiVersion}/submit-trivia-responses/${id}`;
export const getTriviaInsightsSummary = (id) =>
  `/trivia/${apiVersion}/get-trivia-insights-summary/${id}`;
export const getTriviaSubmissions = (id) =>
  `/trivia/${apiVersion}/get-trivia-submissions/${id}`;
export const getTriviaLibrary = `/trivia/${apiVersion}/get-trivia-library`;
export const createTriviaLbraryDoc = `/trivia/${apiVersion}/upload-trivia-resource`;
export const updateTriviaLibraryDoc = (id) =>
  `/trivia/${apiVersion}/update-trivia-resource/${id}`;
export const getMyTakenQuizes = `/trivia/${apiVersion}/my-taken-quizes`;
export const getMyRespondedMessages = `/trivia/${apiVersion}/my-responded-messages`;
export const deleteTriviaResource = (id) =>
  `/trivia/${apiVersion}/delete-trivia-resource/${id}`;
// Add endpoint for renaming trivia resource
export const renameTriviaResource = (id) =>
  `/trivia/${apiVersion}/rename-trivia-resource/${id}`;
export const addTriviaResponseForGuest = `/public/add-trivia-for-external-user`;
export const submitTriviaResponseForGuest = (id) =>
  `/public/submit-trivia-for-external-user/${id}`;
export const submitMessagingResponseForExternalUser = (id) =>
         `/public/externalUsersSubmitMessagingTrivvy/${id}`;
export const getTriviaForQuizExtrenalUser = (id) =>
  `/public/get-trivia-for-external-user/${id}/quiz`;

export const storeShareLogs = `/shareLogs/${apiVersion}/store-share-data`;
export const getTriviaRewardsList = `/trivia/${apiVersion}/get-list-rewards`;
export const writeCurrentTriviaTopScores = `/trivia/${apiVersion}/write-current-trivia-top-scores`;
export const writeCurrentTriviaTopScoresPublic = `/public/write-current-trivia-top-scores-public`;
export const computeRewardsTopWinners = `/trivia/${apiVersion}/compute-reward-top-winners`;

export const uploadUsersForTrivvy = `/users/${apiVersion}/uploadMembersForTrivvy`;
export const reInviteUsers = `/users/${apiVersion}/reInviteUsers`;
export const uploadUsersForTrivvyFromCsv = `/users/${apiVersion}/uploadMembersForTrivvyFromCsv`;
export const addStarRatingForTrivvy = `/public/rate-quiz`;
export const getRatingsForTrivvy = (id) =>
  `/trivia/${apiVersion}/ratings/${id}`;
export const getCustomRewards = `/trivia/${apiVersion}/get-custom-rewards`;
export const updateReward = (rewardId) =>
  `/trivia/${apiVersion}/update-reward/${rewardId}`;
export const deleteReward = (rewardId) =>
  `/trivia/${apiVersion}/delete-reward/${rewardId}`;
export const deleteRewardTemplate = (rewardId) =>
  `/trivia/${apiVersion}/delete-reward-template/${rewardId}`;
export const createStripeCheckout = () =>
  `/trivia/${apiVersion}/create-stripe-checkout`;
export const getStripeSessionStatus = (id) =>
  `/trivia/${apiVersion}/get-stripe-session-status/${id}`;
export const handlePurchaseSuccess = (id) =>
  `/trivia/${apiVersion}/handle-purchase-success/${id}`;
export const handlePurchaseFailure = (id) =>
  `/trivia/${apiVersion}/handle-purchase-failure/${id}`;
export const applyPurchaseToTrivvy = `/trivia/${apiVersion}/apply-purchase-to-trivvy`;
export const createTrivvyOrgAccountFromWebsiteWithPlan = `/public/create-trivvy-org-account-from-website`;
export const createStripeRecurringcheckoutForWebsitePlans = `/trivia/${apiVersion}/createStripeRecurringcheckoutForWebsitePlans`;
export const handleStripeRecurringcheckoutForWebsitePlans = `/trivia/${apiVersion}/handleStripeRecurringcheckoutForWebsitePlans`;
export const addRemindMeToTrivvyResult = `/trivia/${apiVersion}/addRemindMeToTrivvyResult`;
export const duplicateTrivia = `/trivia/${apiVersion}/duplicate-trivia`;
export const getPaymentPlans = `/category/${apiVersion}/getPaymentPlans`;
export const getMyPendingTrivvys = `/trivia/${apiVersion}/get-pending-trivvys`;
export const updateAdvancedTrivvySettings = `/trivia/${apiVersion}/update-trivia-advance-settings`;
export const sendPlanInquiryEmail = `/organization/${apiVersion}/send-trivvy-plan-inquiry-email`;
export const getTrivvyHolidayTemplates = `/trivia/${apiVersion}/get-trivvy-holiday-templates`;
export const generateTrivvysFromTemplates = `/trivia/${apiVersion}/generateTrivvysFromTemplates`;
export const sumarizeTextInputResponses = `/trivia/${apiVersion}/sumarizeTextInputResponses`;
export const sendUserContactUsMessage = `/users/v1/send-contact-us-inquiry`;
export const rephraseCustomQuestion = `/users/v1/rephraseCustomQuestion`;
export const getRewardOptionsForTrivvy = (id) =>
  `/trivia/${apiVersion}/get-reward-options/${id}`;
export const linkRewardToTrivvy = `/trivia/${apiVersion}/link-rewards-to-trivvy`;
export const unlinkRewardToTrivvy = `/trivia/${apiVersion}/unlink-rewards-to-trivvy`;
export const createTrivvyFromCustomTemplates = `/trivia/${apiVersion}/create-trivvy-from-custom-templates`;
export const regenerateTrivvyQuestionsForCustomTemplates = `/trivia/${apiVersion}/regenerate-questions-custom-templates`;
export const getMyAttemptsAvgDoc = `/trivia/${apiVersion}/get-my-attempts-avg-doc`;
export const getTrivvyResultById = (id) =>
  `/public/get-trivvy-result-by-id/${id}`;

export const getMessagingResultHistoryById =(id,params)=>`/public/get-mesaging-trivvy-response-history/${id}${`?${params.toString()}`}`


export const getTriviaConversation = (triviaResultId) => `/trivia/${apiVersion}/getTriviaConversation/${triviaResultId}`;
export const replyToTriviaResult = `/trivia/${apiVersion}/replyToTriviaResult`;


export const getTriviaLibraryById = (id) =>
  `/trivia/${apiVersion}/get-library-by-id/${id}`;
export const deleteLibraryQuestion = (id) =>
  `/trivia/${apiVersion}/delete-library-question/${id}`;
export const getTriviaLibraryQuestions = (id) =>
  `/trivia/${apiVersion}/get-library-questions/${id}`;
export const generateQuestionsForLibrary = `/trivia/${apiVersion}/generate-questions-for-library`;
export const editLibraryQuestion = `/trivia/${apiVersion}/edit-library-question`;
export const getTrivvysLinkedToLibrary = `/trivia/${apiVersion}/get-trivvys-linked-to-library`;
export const generateLibraryTrivvys = `/trivia/${apiVersion}/generate-library-trivvys`;
export const getStandardCustomTemplates = `/trivia/${apiVersion}/get-standard-custom-templeates`;
export const trivvyKeywordSearch = `/trivia/${apiVersion}/get-trivvy-search-keyword`;
export const createTrivvyComment = `/trivia/${apiVersion}/create-trivvy-comment`;
export const getTrivvyComments = `/trivia/${apiVersion}/get-trivvy-comments`;
export const updateTrivvyComment = `/trivia/${apiVersion}/update-trivvy-comment`;
export const updateTrivvyModalFlag = `/trivia/${apiVersion}/updateTrivvyModalFlag`;
export const storeDropoffs = (id) =>
  `/trivia/${apiVersion}/store-trivia-dropoffs/${id}`;
export const storeDropoffsGuest = (id) =>
  `/public/store-trivia-dropoffs-guest/${id}`;
export const getTrivvyDropoffs = (id) =>
  `/trivia/${apiVersion}/get-trivvy-dropoffs/${id}`;
export const updateTrivvyPublish = (id) =>
  `/trivia/${apiVersion}/update-trivia-publish-status/${id}`;
export const removePendingTrivvy = (id) =>
  `/trivia/${apiVersion}/remove-pending-trivvy/${id}`;
export const updateSharedWithAllUsers = `/trivia/${apiVersion}/updateSharedWithAllUsers`;
export const saveTrivvyShareUsersApi = (id) =>
  `/trivia/${apiVersion}/saveTriviaSharedUsers/${id}`;
export const deleteTriviaSharedUsers = (id) =>
         `/trivia/${apiVersion}/deleteTriviaSharedUsers/${id}`;
export const sendTrivvyToSharedUsers = (id) =>
  `/trivia/${apiVersion}/sendTrivvyToSavedTriviaUsers/${id}`;
export const getTrivvySharedSMSPreview = (id) =>
         `/trivia/${apiVersion}/getTrivvySharedSMSPreview/${id}`;
export const getTrivvySharedEmailPreview = (id) =>
         `/trivia/${apiVersion}/getTrivvySharedEmailPreview/${id}`;
export const getEmailEligibleUserCount = (id) =>
         `/trivia/${apiVersion}/getEmailEligibleUserCount/${id}`;
export const getSmsEligibleUserCount = (id) =>
         `/trivia/${apiVersion}/getSmsEligibleUserCount/${id}`;
export const getSmsUserCountForTrivia = (id) =>
         `/trivia/${apiVersion}/getSmsUserCountForTrivia/${id}`;
export const getMessagingUserCountForTrivia = (id) =>
         `/trivia/${apiVersion}/getMessagingUserCountForTrivia/${id}`;
export const createOrScheduleMultipleTrivvys = `/trivia/${apiVersion}/schedule-or-create-trivvy`;
export const deleteMultipleUsers = `/users/${apiVersion}/deleteMultipleUsers`;
export const editFontSettings = `/trivia/${apiVersion}/edit-trivvy-font-settings`;
export const generateAndStoreSummaryForLibrarySource = (id) =>
  `/trivia/${apiVersion}/generateAndStoreSummaryForLibrarySource/${id}`;
export const uploadDocumentForTrivvy = `/trivia/${apiVersion}/upload-document-for-trivvy`;
export const readContentAndCreateQuestions = `/trivia/${apiVersion}/readContentAndCreateQuestions`;
export const translateQuestionsData = `/trivia/${apiVersion}/translateQuestionsData`;
export const createTrivvysFinal = `/trivia/${apiVersion}/createTrivvysFinal`;
export const regenerateQuestionForTrivvy = `/trivia/${apiVersion}/regenerateQuestionForTrivvy`;
export const updateTrivvyPublishMultiple = `/trivia/${apiVersion}/update-multiple-trivia-publish-status`;
export const deleteMultipleTrivias = `/trivia/${apiVersion}/delete-multiple-trivia`;
export const deleteMultipleLibrarys = `/trivia/${apiVersion}/delete-multiple-library`;
export const getUsersToRemind = (id) =>
  `/trivia/${apiVersion}/get-trivvy-remind-users/${id}`;
export const sendTrivvyReminders = `/trivia/${apiVersion}/send-trivvy-reminders`;
export const shareTriviaAsTextSurvey = `/trivia/${apiVersion}/share-trivvy-as-text-survey`;
export const generateQuestionsForBuiltWithAitrivvy = `/trivia/${apiVersion}/generateQuestionsForBuiltWithAitrivvy`;

export const handleSubmitMMQuestions = `/surveys/${apiVersion}/submit-mm-questions`;
export const getMMQuestionsByDate = `/surveys/${apiVersion}/get-mm-questions-by-date`;
export const triggerScoreCalculation = `/surveys/${apiVersion}/trigger-mm-score-calculation`;
export const handleEditSubmitMMQuestions = `/surveys/${apiVersion}/edit-submit-mm-questions`;
export const getScoreByDate = `/surveys/${apiVersion}/get-score-by-date`;
export const getChartsDataForMMByDates = `/surveys/${apiVersion}/get-charts-data-by-dates`;
export const getMMBenchmarksList = `/surveys/${apiVersion}/get-mm-benchmarks`;
export const updateBenchmarkForReport = `/surveys/${apiVersion}/update-benchmark-for-report`;
export const getBenchmarkForTrends = `/surveys/${apiVersion}/get-benchmark-for-trends`;
export const handleSubmitMMQuestionsExternal = `/public/submit-mm-questions-external`;
export const getMMBenchmarksData = `/public/getMMBenchmarksData`;
export const getReportByUserKey = `/public/get-report-for-external-user`;
export const handleMMExternalUserLogin = `/public/handle-mm-external-user-login`;
export const getExternalUserMMScores = `/public/get-external-user-mm-scores`;
export const handleUserOrgUpgrate = `/public/handle-user-org-upgrade`;
export const updateBenchmarkForReportExternal = `/public/update-benchmark-for-report-external`;
export const updateQuestionsForExternalUserScoreObject = `/public/update-questions-for-external-user-score`;
export const getDiversityCalendarGuides = `/toolkit/${apiVersion}/tools/get-diversity-calendar-tools`;
export const sendEmailToOurofficeSupport = `/users/${apiVersion}/sendEmailToOurofficeSupport`;
export const verifyDateFormatFromCSV = `/users/${apiVersion}/verifyDateFormatFromCSV`;
export const searchUsersByMetaData = `/users/${apiVersion}/searchUsersByMetaData`;


export const createAndSendIsMessageTypeTrivvy = `/trivia/${apiVersion}/createAndSendIsMessageTypeTrivvy`;
export const getIsMessageTrivvys = `/trivia/${apiVersion}/get-is-message-trivvys`;
export const fetchMessagingTrivvyAnalyticsResults = (triviaId) =>
  `/trivia/${apiVersion}/fetch-messaging-trivvy-analytics-results/${triviaId}`;
export const getMessagingResponseRecommendations = (triviaId) =>
  `/trivia/${apiVersion}/get-mesaging-response-recommendations/${triviaId}`;
export const getMessagingResponses = (triviaId) =>
  `/trivia/${apiVersion}/get-mesaging-trivvy-responses/${triviaId}`;
export const getTriviaInsights = (triviaId) =>
  `/trivia/${apiVersion}/get-trivia-insights/${triviaId}`;
export const generateInsightsForTrivvyNonTextTypeQuestions = `/trivia/${apiVersion}/generateInsightsForTrivvyNonTextTypeQuestions`;
export const generateInsightsForTextTrivvyQuestion = `/trivia/${apiVersion}/generateInsightsForTextTrivvyQuestion`;
export const resendIsMessagingTrivvyToUsers = `/trivia/${apiVersion}/resendIsMessagingTrivvyToUsers`;
export const sendTrivvyLinkAsTxt = `/trivia/${apiVersion}/sendTrivvyLinkAsTxt`;
export const getMsgHelpChatsByPhoneNumberAndDate = `/public/getMsgHelpChatsByPhoneNumberAndDate`;
export const getQuestionReply = `/public/get-question-reply`;
export const generateVideoInstructionsForAMessage = `/public/generateVideoInstructionsForAMessage`;
export const getAdditionalVideosForResponse = `/public/getAdditionalVideosForResponse`;
export const getMoreYoutubeVideosForResponse = `/public/getMoreYoutubeVideosForResponse`;
export const handleMessageHelpPhotoUpload = `/public/handleMessageHelpPhotoUpload`;
export const getAllConversationsByNumber = `/public/getAllConversationsByNumber`;
export const handleNewConversationCreate = `/public/handleNewConversationCreate`;
export const getResponsesForSentiments = `/trivia/${apiVersion}/getResponsesForSentiments`;
export const updateSelectedActionsForInsights = `/trivia/${apiVersion}/updateSelectedActionsForInsights`;
export const shareSurveyInsightsActions = `/trivia/${apiVersion}/shareSurveyInsightsActions`;
export const updateIndustryMissionValues = `/trivia/${apiVersion}/updateIndustryMissionValues`;
export const readContentForTrivvy = `/trivia/${apiVersion}/readContentForTrivvy`;
export const saveOrgUserMetaData = `/orgUserMetaData/${apiVersion}/metadatasave`;
export const getOrgUserMetaData = `/orgUserMetaData/${apiVersion}/metadataget/latest`;
export const getAllOrgUserMetaData = `/orgUserMetaData/${apiVersion}/metadataget/all`;



export const updateAllOrgUserMetaData = `/orgUserMetaData/${apiVersion}/metadataupdate`;
export const deleteTriviaUserShares = `/triviaUserShares/${apiVersion}/delete`;

export const submitMessagingResponse = (id) =>
         `/trivia/${apiVersion}/submitMessagingResponse`;

export const getMessagingResultHistoryByIdForSpecificUser = (id,params)=>
         `/trivia/${apiVersion}/get-mesaging-trivvy-response-history/${id}${`?${params.toString()}`}`;
